'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var sanitizeHtml = require('sanitize-html');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var filterCSSStyles = require('./lib/filterCSSStyles.js');
var SkipToContent = require('./SkipToContent.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);
var sanitizeHtml__default = /*#__PURE__*/_interopDefaultLegacy(sanitizeHtml);

let TagName = /*#__PURE__*/function (TagName) {
  TagName["A"] = "A";
  TagName["IMG"] = "IMG";
  return TagName;
}({});
const svgDescendantSelector = 'svg *';
const DynamicHeader = _ref => {
  let {
    featureName,
    templateRenderingContext,
    skipToContent
  } = _ref;
  const {
    trackHeader
  } = nthHookSettings.useSettings();
  const {
    html,
    querySelectors,
    sticky: stickyIn
  } = trackHeader || {};
  const sticky = stickyIn === null || stickyIn === undefined || stickyIn;
  const extractedStyles = [];

  // TODO: Sanitize this html only on the back end.
  const htmlString = sanitizeHtml__default["default"](html || '', {
    // setting these to false allows all tags and attributes
    // TODO: decide which set of tags and attributes to allow in headers
    // Can use TagType and AttributeType enums
    allowedTags: false,
    allowVulnerableTags: true,
    allowedAttributes: false,
    exclusiveFilter: frame => {
      // extract any style tag and remove it from the original html
      if (frame.tag === 'style') {
        extractedStyles.push(filterCSSStyles["default"](frame.text));
        return true;
      }
      return false;
    },
    // We wrap the header html string in a <header> below, which creates nested <header>
    // elements if the header html also has a <header>. Since we wrap the html in a
    // <header>, transform any <header> elements to divs.
    transformTags: {
      header: 'div',
      h1: function (tagName, attribs) {
        // Turn off the semantic meaning of any h1 in the header HTML.
        // An h1 should be provided by the specific product instead.
        return {
          tagName,
          attribs: {
            ...attribs,
            role: 'presentation'
          }
        };
      }
    }
  });

  // for now we are allowing template variables anywhere in the header html
  const templatedHtmlString = mustache__default["default"].render(htmlString, templateRenderingContext);

  // Our original header html contains ids. Duplicating this header for the
  // sticky header effect creates duplicate ids, which is invalid html.
  // This destructures `id` out of attribs
  const hiddenHtmlTagTransform = (tagName, // eslint-disable-next-line @typescript-eslint/no-unused-vars
  _ref2) => {
    let {
      id,
      ...attribs
    } = _ref2;
    return {
      tagName,
      attribs
    };
  };
  const hiddenHtmlString = sanitizeHtml__default["default"](templatedHtmlString || '', {
    allowedTags: false,
    allowVulnerableTags: true,
    allowedAttributes: false,
    transformTags: {
      '*': hiddenHtmlTagTransform
    }
  });
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const baseLogInfo = {
    eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_DYNAMIC_HEADER,
    eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_DYNAMIC_HEADER,
    pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_BUNDLE_DYNAMIC_HEADER,
    feature: featureName
  };
  React.useEffect(() => {
    logEvent({
      ...baseLogInfo,
      eventType: nthHookContextAnalytics.NarvarEventTypes.COMPONENT_RENDER
    });
  },
  // TODO: Make this dependency array exhaustive
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  const header = /*#__PURE__*/React__default["default"].createElement("header", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: templatedHtmlString
    }
  });
  const hiddenHeader = /*#__PURE__*/React__default["default"].createElement("header", {
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML: {
      __html: hiddenHtmlString
    }
  });
  return /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      position: 'relative'
    }
  }, skipToContent && /*#__PURE__*/React__default["default"].createElement(SkipToContent["default"], {
    targetId: skipToContent.targetId,
    scrollToTarget: skipToContent.scrollToTarget
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      whiteSpace: 'normal',
      ...(sticky && {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 99
      })
    },
    onClick: event => {
      const element = event.target;
      if (!(element instanceof Element)) return;
      const href = element.getAttribute('href');
      const {
        tagName,
        innerHTML: clickLabel
      } = element;
      let isImage = false;
      switch (tagName) {
        case TagName.IMG:
          {
            isImage = true;
            break;
          }
        case TagName.A:
          {
            break;
          }
        default:
          {
            if (!element.matches && !element.msMatchesSelector || element.matches && !element.matches(svgDescendantSelector) || element.msMatchesSelector && !element.msMatchesSelector(svgDescendantSelector)) {
              return;
            }
            isImage = true;
          }
      }
      const logoAssetPayload = isImage ? {
        clickAssetId: (querySelectors || []).find(querySelector => {
          if (!querySelector) return false;
          if (element.matches) return element.matches(querySelector);
          if (element.msMatchesSelector) return element.msMatchesSelector(querySelector);
          return false;
        }),
        clickAssetType: tagName,
        clickAssetUrl: href,
        clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.LOGO_ASSET,
        clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.LOGO_ASSET
      } : {};
      logEvent({
        ...baseLogInfo,
        clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.NAVIGATION_ELEMENT,
        clickLinkDestinationUrl: href,
        clickLinkLabel: clickLabel,
        clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.NAVIGATION_ELEMENT,
        clickType: nthHookContextAnalytics.NarvarClickTypes.OUTGOING,
        eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
        ...logoAssetPayload
      });
    }
  }, extractedStyles.length > 0 && /*#__PURE__*/React__default["default"].createElement("style", null, extractedStyles.join(' ')), header), sticky && /*#__PURE__*/React__default["default"].createElement("div", {
    "aria-hidden": true,
    style: {
      visibility: 'hidden',
      whiteSpace: 'normal'
    }
  }, hiddenHeader));
};
var index = nthHookSettings.withSettingsProvider(DynamicHeader, {
  settingsRequested: `
    trackHeader {
      html
      querySelectors
      sticky
    }
  `
});

exports.TagName = TagName;
exports["default"] = index;
